import { createModalHook } from '@change-corgi/design-system-legacy/modals';

import type { Recommendation } from 'src/app/pages/starterDashboardV2/shared/contexts';

import { FeedbackBody } from '../../components/FeedbackBody';

export type ModalOptions = {
	recommendationGroup: string;
	recommendation: Recommendation;
};

export type ModalResult = {
	submitted?: boolean;
};

export const useFeedbackModal = createModalHook<ModalOptions, ModalResult>({
	closeButton: true,
	name: 'SharingRecommendationsFeedbackModal',
	body: function ModalBody({ options, closeModal }) {
		return <FeedbackBody onClose={closeModal} options={options} />;
	},
});
